import React from 'react';

// helpers
import {useTheme} from '@emotion/react';
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../helpers';

// components
import {Link} from 'react-router-dom';
import {Button} from '@mui/joy';

// styles
import {
  ActionButtonWrapper,
  ActionColumnHeaderItem,
  StyledLink,
  ClickableTableCell,
  TableHeaderItem,
  TableRow,
  TableWrapper,
} from './Table-styles';
import {IconRightArrow, TextDefault, TextSmall} from '../../styles';

// types
import {Loan} from '../../services/ApiService/types';

type Props = {
  loans: Loan[];
};

const TableLoans = ({loans}: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <TableWrapper borderAxis="none">
      <thead>
        <tr>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('loan_loanNumber')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_date')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_status')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('loan_loanAmount')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_currentBalance')}</TextDefault>
          </TableHeaderItem>
          <ActionColumnHeaderItem />
        </tr>
      </thead>
      <tbody>
        {loans.map((loan) => {
          const navigationPath = `/loans/${loan.id}`;
          return (
            <TableRow key={loan.id}>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>#{loan.loanNumber}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{loan.startDate}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{loan.status}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{formatCurrency(loan.amount)}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{formatCurrency(loan.currentBalance)}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ActionButtonWrapper>
                <Button
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: theme.border.radius.xxs,
                  }}
                  variant="outlined"
                  endDecorator={<IconRightArrow />}
                  component={Link}
                  to={navigationPath}>
                  {t('global_details')}
                </Button>
              </ActionButtonWrapper>
            </TableRow>
          );
        })}
      </tbody>
    </TableWrapper>
  );
};

export default TableLoans;
